interface EbookCoverProps {
  ebookId: string;
  badge?: string;
}

const covers: Record<string, {
  bg: string;
  accent: string;
  accentLight: string;
  icon: string;
  label: string;
  titleLines: string[];
  pattern: 'grid' | 'circles' | 'lines' | 'diamonds';
  textColor: string;
}> = {
  'ebook-ergonomia-nr17': {
    bg: 'linear-gradient(160deg, #1A2533 0%, #0D1B2A 60%, #1C2E1A 100%)',
    accent: '#E8610A',
    accentLight: 'rgba(232,97,10,0.15)',
    icon: 'ri-shield-check-line',
    label: 'ERGONOMIA & COMPLIANCE',
    titleLines: ['Guia Prático', 'NR-17'],
    pattern: 'grid',
    textColor: '#fff',
  },
  'ebook-escritorio-zero': {
    bg: 'linear-gradient(160deg, #2A1F14 0%, #1C1C1C 55%, #2E2516 100%)',
    accent: '#E8A00A',
    accentLight: 'rgba(232,160,10,0.15)',
    icon: 'ri-building-2-line',
    label: 'PLANEJAMENTO & DESIGN',
    titleLines: ['Escritório', 'do Zero'],
    pattern: 'lines',
    textColor: '#fff',
  },
  'ebook-recepcao-vende': {
    bg: 'linear-gradient(160deg, #2E1A14 0%, #1C1C1C 55%, #3D1A10 100%)',
    accent: '#D4856A',
    accentLight: 'rgba(212,133,106,0.15)',
    icon: 'ri-sofa-line',
    label: 'EXPERIÊNCIA DO CLIENTE',
    titleLines: ['A Recepção', 'que Vende'],
    pattern: 'circles',
    textColor: '#fff',
  },
  'ebook-advocacia': {
    bg: 'linear-gradient(160deg, #1A2E28 0%, #1C1C1C 50%, #2A1E10 100%)',
    accent: '#7EB89A',
    accentLight: 'rgba(126,184,154,0.15)',
    icon: 'ri-scales-3-line',
    label: 'ESCRITÓRIO DE ADVOCACIA',
    titleLines: ['Advocacia', 'que Fecha'],
    pattern: 'diamonds',
    textColor: '#fff',
  },
  'ebook-escolar-2026': {
    bg: 'linear-gradient(160deg, #0D3D28 0%, #1A6B4A 45%, #1C1C1C 100%)',
    accent: '#FF9A6C',
    accentLight: 'rgba(255,154,108,0.15)',
    icon: 'ri-school-line',
    label: 'EDUCAÇÃO · 2026',
    titleLines: ['Escola', 'do Futuro'],
    pattern: 'grid',
    textColor: '#fff',
  },
  'ebook-clinicas': {
    bg: 'linear-gradient(160deg, #0A2A2A 0%, #1A6B6B 45%, #1C1C1C 100%)',
    accent: '#7ECECE',
    accentLight: 'rgba(126,206,206,0.15)',
    icon: 'ri-hospital-line',
    label: 'CLÍNICAS MÉDICAS',
    titleLines: ['Ambiente', 'que Cura'],
    pattern: 'circles',
    textColor: '#fff',
  },
  'ebook-hotelaria': {
    bg: 'linear-gradient(160deg, #1A1408 0%, #2D2010 50%, #1C1C1C 100%)',
    accent: '#D4A843',
    accentLight: 'rgba(212,168,67,0.15)',
    icon: 'ri-hotel-bed-line',
    label: 'HOTELARIA',
    titleLines: ['Check-out', '5 Estrelas'],
    pattern: 'diamonds',
    textColor: '#fff',
  },
  'ebook-academia': {
    bg: 'linear-gradient(160deg, #1A0808 0%, #2D1010 50%, #1C1C1C 100%)',
    accent: '#E88080',
    accentLight: 'rgba(232,128,128,0.15)',
    icon: 'ri-heart-pulse-line',
    label: 'ACADEMIA & FITNESS',
    titleLines: ['Academia', 'que Retém'],
    pattern: 'lines',
    textColor: '#fff',
  },
  'ebook-imobiliaria': {
    bg: 'linear-gradient(160deg, #0A1E30 0%, #1A3A5C 50%, #1C1C1C 100%)',
    accent: '#7EB8E8',
    accentLight: 'rgba(126,184,232,0.15)',
    icon: 'ri-building-line',
    label: 'IMOBILIÁRIAS',
    titleLines: ['Fecha', 'Negócios'],
    pattern: 'grid',
    textColor: '#fff',
  },
  'ebook-farmacia': {
    bg: 'linear-gradient(160deg, #0A2A18 0%, #1A6B3A 50%, #1C1C1C 100%)',
    accent: '#7ECFA0',
    accentLight: 'rgba(126,207,160,0.15)',
    icon: 'ri-medicine-bottle-line',
    label: 'FARMÁCIAS',
    titleLines: ['Layout que', 'Vende Mais'],
    pattern: 'circles',
    textColor: '#fff',
  },
};

function PatternGrid({ color }: { color: string }) {
  return (
    <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" style={{ position: 'absolute', inset: 0, opacity: 0.07 }}>
      <defs>
        <pattern id="pg" width="24" height="24" patternUnits="userSpaceOnUse">
          <path d="M 24 0 L 0 0 0 24" fill="none" stroke={color} strokeWidth="0.8"/>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#pg)" />
    </svg>
  );
}

function PatternLines({ color }: { color: string }) {
  return (
    <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" style={{ position: 'absolute', inset: 0, opacity: 0.07 }}>
      <defs>
        <pattern id="pl" width="20" height="20" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
          <line x1="0" y1="0" x2="0" y2="20" stroke={color} strokeWidth="1.2"/>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#pl)" />
    </svg>
  );
}

function PatternCircles({ color }: { color: string }) {
  return (
    <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" style={{ position: 'absolute', inset: 0, opacity: 0.06 }}>
      <defs>
        <pattern id="pc" width="30" height="30" patternUnits="userSpaceOnUse">
          <circle cx="15" cy="15" r="10" fill="none" stroke={color} strokeWidth="0.8"/>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#pc)" />
    </svg>
  );
}

function PatternDiamonds({ color }: { color: string }) {
  return (
    <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" style={{ position: 'absolute', inset: 0, opacity: 0.07 }}>
      <defs>
        <pattern id="pd" width="28" height="28" patternUnits="userSpaceOnUse">
          <polygon points="14,2 26,14 14,26 2,14" fill="none" stroke={color} strokeWidth="0.8"/>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#pd)" />
    </svg>
  );
}

export default function EbookCover({ ebookId, badge }: EbookCoverProps) {
  const c = covers[ebookId];
  if (!c) return null;

  return (
    <div
      className="relative w-full h-full overflow-hidden rounded-xl"
      style={{ background: c.bg }}
    >
      {/* Background pattern */}
      {c.pattern === 'grid' && <PatternGrid color={c.accent} />}
      {c.pattern === 'lines' && <PatternLines color={c.accent} />}
      {c.pattern === 'circles' && <PatternCircles color={c.accent} />}
      {c.pattern === 'diamonds' && <PatternDiamonds color={c.accent} />}

      {/* Glow orb */}
      <div
        className="absolute rounded-full"
        style={{
          width: '120px', height: '120px',
          top: '-20px', right: '-20px',
          background: `radial-gradient(circle, ${c.accent}30 0%, transparent 70%)`,
        }}
      />
      <div
        className="absolute rounded-full"
        style={{
          width: '80px', height: '80px',
          bottom: '20px', left: '-10px',
          background: `radial-gradient(circle, ${c.accentLight} 0%, transparent 70%)`,
        }}
      />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-between p-4">

        {/* Top: label + badge */}
        <div className="flex items-start justify-between">
          <span
            className="text-[9px] font-bold tracking-widest uppercase leading-tight"
            style={{ color: c.accent, maxWidth: '80px' }}
          >
            {c.label}
          </span>
          {badge && (
            <span
              className="text-[9px] font-bold px-2 py-0.5 rounded-full whitespace-nowrap"
              style={{ background: c.accent, color: '#fff' }}
            >
              {badge}
            </span>
          )}
        </div>

        {/* Middle: big icon */}
        <div className="flex justify-center items-center flex-1">
          <div
            className="rounded-2xl flex items-center justify-center"
            style={{
              width: '56px', height: '56px',
              background: `${c.accent}22`,
              border: `1.5px solid ${c.accent}55`,
            }}
          >
            <i className={`${c.icon} text-2xl`} style={{ color: c.accent }}></i>
          </div>
        </div>

        {/* Bottom: title + brand */}
        <div>
          <div
            className="h-px w-8 mb-2"
            style={{ background: c.accent }}
          />
          {c.titleLines.map((line, i) => (
            <p
              key={i}
              className={`leading-tight font-black ${i === 0 ? 'text-base opacity-70' : 'text-xl'}`}
              style={{
                fontFamily: "'Playfair Display', serif",
                color: c.textColor,
              }}
            >
              {line}
            </p>
          ))}
          <p
            className="text-[9px] mt-2 font-semibold tracking-wider uppercase"
            style={{ color: 'rgba(255,255,255,0.3)' }}
          >
            Home Office Premium
          </p>
        </div>
      </div>

      {/* Side stripe */}
      <div
        className="absolute top-0 right-0 w-1 h-full"
        style={{ background: `linear-gradient(to bottom, ${c.accent}, transparent)` }}
      />
    </div>
  );
}
